import RenderImagesPreview from './RenderImagesPreview'
import renderImagesPreviewContainer from './renderImagesPreviewContainer'

export default renderImagesPreviewContainer(RenderImagesPreview)
